import {
  BulbSuggestionIcon,
  DescriptionIcon,
  InformationIcon,
  SparkleIcon,
} from "@hightouch/htui";
import type { UserMenuItemProps } from "src/components/layout/header/user-menu";
import { useUser } from "src/contexts/user-context";
import * as analytics from "src/lib/analytics";
import { newPylonMessage } from "src/lib/pylon";

/** Hightouch's docs, status, and changelog, and a way to send feedback: the user menu's Resources rows, and the canvas nav's list. */
export const useResourceLinks = (): UserMenuItemProps[] => {
  const { workspace } = useUser();
  const track = (event: string) => () =>
    analytics.track(event, { workspace_id: workspace?.id });

  return [
    {
      href: import.meta.env.VITE_DOCS_URL,
      icon: DescriptionIcon,
      label: "Documentation",
      onClick: track("Docs Clicked"),
    },
    {
      href: "https://status.hightouch.io",
      icon: InformationIcon,
      label: "System status",
      onClick: track("Status Page Clicked"),
    },
    {
      href: "https://docs.hightouch.com/changelog",
      icon: SparkleIcon,
      label: "Product updates",
      onClick: track("Changelog Clicked"),
    },
    {
      icon: BulbSuggestionIcon,
      label: "Feedback",
      onClick: () => {
        // Event name pinned to master's value to avoid breaking analytics; the
        // Pylon prefill matches the current "Feedback" label.
        track("Feedback Menu: Submit feature request clicked.")();
        newPylonMessage("Hi, I have some feedback.");
      },
    },
  ];
};
